import { render, staticRenderFns } from "./course-list-item.vue?vue&type=template&id=aef3a83e&scoped=true"
import script from "./course-list-item.vue?vue&type=script&lang=js"
export * from "./course-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef3a83e",
  null
  
)

export default component.exports